import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Input, Output, HostListener, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
/**
 * @element ons-input
 * @directive OnsInput
 * @selector ons-input
 * @description
 *   [en]Angular directive for `<ons-input>` component.[/en]
 *   [ja]`<ons-input>`要素のAngularディレクティブです。[/ja]
 * @example
 *   <ons-input [(value)]="value"></ons-input>
 */
var OnsInput = /** @class */ (function () {
    function OnsInput(_elementRef) {
        this._elementRef = _elementRef;
        this._propagateChange = function (_) { };
        this._propagateTouched = function () { };
        /**
         * @output valueChange
         * @type {string}
         * @desc
         *   [en]Triggers when the value is changed.[/en]
         *   [ja]内部の`input`要素の値が変更された時に発火します。[/ja]
         */
        this._valueChange = new EventEmitter();
        this._boundOnChange = this._onChange.bind(this);
        this._element = _elementRef.nativeElement;
        this._element.addEventListener('input', this._boundOnChange);
    }
    OnsInput_1 = OnsInput;
    OnsInput.prototype._onChange = function (event) {
        this._valueChange.emit(this._element.value);
        this._propagateChange(this._element.value);
    };
    OnsInput.prototype._onBlur = function () {
        this._propagateTouched();
    };
    OnsInput.prototype.ngOnChanges = function (changeRecord) {
        var value = changeRecord['_value'].currentValue;
        if (this._element.value !== value) {
            this._element.value = value;
        }
    };
    Object.defineProperty(OnsInput.prototype, "element", {
        get: function () {
            return this._element;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OnsInput.prototype, "nativeElement", {
        get: function () {
            return this._element;
        },
        enumerable: true,
        configurable: true
    });
    OnsInput.prototype.ngOnDestroy = function () {
        this._element.removeEventListener('input', this._boundOnChange);
        this._element = null;
    };
    OnsInput.prototype.writeValue = function (obj) {
        this._element.value = obj;
    };
    OnsInput.prototype.registerOnChange = function (fn) {
        this._propagateChange = fn;
    };
    OnsInput.prototype.registerOnTouched = function (fn) {
        this._propagateTouched = fn;
    };
    var OnsInput_1;
    __decorate([
        Input('value'),
        __metadata("design:type", String)
    ], OnsInput.prototype, "_value", void 0);
    __decorate([
        Output('valueChange'),
        __metadata("design:type", EventEmitter)
    ], OnsInput.prototype, "_valueChange", void 0);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OnsInput.prototype, "_onBlur", null);
    OnsInput = OnsInput_1 = __decorate([ __metadata("design:paramtypes", [ElementRef])
    ], OnsInput);
OnsInput.ɵfac = function OnsInput_Factory(t) { return new (t || OnsInput)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OnsInput.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: OnsInput, selectors: [["ons-input"]], hostBindings: function OnsInput_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function OnsInput_blur_HostBindingHandler() { return ctx._onBlur(); });
    } }, inputs: { _value: ["value", "_value"] }, outputs: { _valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(function () { return OnsInput_1; }),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnsInput, [{
        type: Directive,
        args: [{
                selector: 'ons-input',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return OnsInput_1; }),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _valueChange: [{
            type: Output,
            args: ['valueChange']
        }], _onBlur: [{
            type: HostListener,
            args: ['blur']
        }], _value: [{
            type: Input,
            args: ['value']
        }] }); })();
    return OnsInput;
}());
export { OnsInput };

//# sourceMappingURL=ons-input.js.map